import { connect } from 'react-redux'
import Shortener from 'components/Shortener'
import { shortenLink } from 'async/shorten'
import { bindActionCreators } from 'redux'


const ShortenerContainer = connect(
    state => state.ui,
    dispatch => ({
      submit: bindActionCreators(shortenLink, dispatch),
    })
)(Shortener)

export default ShortenerContainer;




// WEBPACK FOOTER //
// ./src/containers/ShortenerContainer.jsx